import { TealiumDerivedEventData, TealiumReactHookDerivedPageViewEventData } from 'pubsub/tealium'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getUserLoggedInState } from 'redux/reducers/users'

export const useDerivedTealiumEventData = () => {
  const authenticated = useSelector(getUserLoggedInState)
  const { i18n } = useTranslation()

  const derivedData = useMemo((): TealiumDerivedEventData => {
    return {
      // eslint-disable-next-line quote-props
      'logged_in': authenticated ? 'true' : 'false'
    }
  }, [authenticated])

  const derivedPageViewData = useMemo((): TealiumReactHookDerivedPageViewEventData => {
    return {
      content_language: i18n.language,
      ...derivedData
    }
  }, [derivedData, i18n.language])

  return {
    derivedData,
    derivedPageViewData
  }
}
